<template>
    <div class="form-group">
        <label :for="name">{{ label }}</label>
        <input :class="{errors: isErrors}" type="email" :id="name" class="form-control" :name="name" v-model="proxyValue"/>
        <ul class="error-placeholder" v-if="isErrors">
            <li v-for="error in errors">{{ error }}</li>
        </ul>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        label: {
            Type: String,
        },
        name: {
            Type: String,
        },
        parentIndex: {
            Type: String,
        },
    },
    computed: {
        isErrors() {
            return this.errors.length > 0;
        },
        proxyValue: {
            get() { return this.value; },
            set(newValue) { this.$emit('input', newValue); }
        }
    },
    data() {
        return {
            errors: [],
            value: null,
        };
    },
    mounted() {
        this.mountEvents();
    },
    methods: {
        mountEvents() {
            let eventManagerService = this.$root.getEventManager();

            this.$root.$on('FormComponent:submit-errors', (errors) => {
                this.resetErrors();

                if (errors[this.name]) {
                    this.errors = errors[this.name];
                }
            });

            this.$root.$on('FormComponent:show-component', () => {
                this.resetErrors();
            });
        },
        resetErrors() {
            this.errors = [];
        },
        setValue(config, value) {
            this.value = value[this.name];
        },
    }
}

</script>

<style>
    .error-placeholder {
        color: red;
        font-size: 0.9em;
    }
    .errors {
        border: 1px solid red;
    }
</style>


// WEBPACK FOOTER //
// EmailInput.vue?6c78ecc3